import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/trophy.gif'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<h5 class=\"font-semibold mb-[2px]\"> Congratulations, <span class=\"text-primary-500\">Olivia!</span></h5><p class=\"mb-[14px]\">Best agent of the month</p><h6 class=\"text-secondary-500 text-[20px] mb-[1px]\">1.5k+</h6><span class=\"block\"> Ticket Solved </span>", 4)),
      _createVNode(_component_RouterLink, {
        to: "/my-profile",
        class: "inline-block font-medium rounded-md text-primary-50 bg-primary-500 mt-[16px] px-[9.3px] py-[3.5px] transition-all hover:bg-primary-400"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" View Profile ")
        ])),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "absolute bottom-0 ltr:right-0 rtl:left-0 max-w-[130px] md:max-w-[152px]",
        alt: "trophy-image"
      }, null, -1))
    ])
  ]))
}